import { BaseModel } from "../base.model";

export class EmailTemplateBaseModel extends BaseModel {
    name: string = "";
    emailSubject: string = "";
    senderName: string = "";
    senderEmail: string = "";
    content: string = "";
}
